import { assign, clone, cloneDeep, find, remove } from 'lodash'

import {
  POST_LIST_ADD,
  POST_LIST_ADD_CANCELED,
  POST_LIST_ADD_ERROR,
  POST_LIST_ADD_FULFILLED,
  POST_LIST_DELETE,
  POST_LIST_DELETE_CANCELED,
  POST_LIST_DELETE_ERROR,
  POST_LIST_DELETE_FULFILLED,
  POST_LIST_FETCH,
  POST_LIST_FETCH_CANCELED,
  POST_LIST_FETCH_ERROR,
  POST_LIST_FETCH_FULFILLED,
  POST_LIST_INITIAL_STATE,
  POST_REACTION_ADD,
  POST_REACTION_ADD_CANCELED,
  POST_REACTION_ADD_ERROR,
  POST_REACTION_ADD_FULFILLED,
  POST_REACTION_DELETE,
  POST_REACTION_DELETE_CANCELED,
  POST_REACTION_DELETE_ERROR,
  POST_REACTION_DELETE_FULFILLED,
} from './PostListActions'

const addReaction = (state, action = {}) => {
  const data = cloneDeep(state.data)
  const post = find(data, { post_id: action.payload.typeId }) || find(data, { id: action.payload.typeId })
  if (post) {
    const content = post.post || post
    content.reactions = content.reactions || []
    content.reactions_summary = content.reactions_summary || []

    if (!find(content.reactions, { reaction: action.payload.reaction })) {
      content.reactions.push({ reaction: action.payload.reaction })
    }
    const summary = find(content.reactions_summary, { reaction: action.payload.reaction })
    if (summary) {
      summary.count += 1
    } else {
      content.reactions_summary.push({
        count: 1,
        reaction: action.payload.reaction,
      })
    }
    return assign({}, state, { data, error: null })
  }
  return state
}

const delReaction = (state, action = {}) => {
  const data = cloneDeep(state.data)
  const post = find(data, { post_id: action.payload.typeId }) || find(data, { id: action.payload.typeId })
  if (post) {
    const content = post.post || post
    content.reactions = content.reactions || []
    content.reactions_summary = content.reactions_summary || []

    remove(content.reactions, { reaction: action.payload.reaction })
    const summary = find(content.reactions_summary, { reaction: action.payload.reaction })
    if (summary) {
      summary.count -= 1
      if (summary.count === 0) {
        remove(content.reactions_summary, { reaction: action.payload.reaction })
      }
    }
    return assign({}, state, { data, error: null })
  }
  return state
}

export default (state = POST_LIST_INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case POST_LIST_ADD: {
      return assign({}, state, { error: null })
    }
    case POST_LIST_ADD_CANCELED: {
      return assign({}, state, { error: null })
    }
    case POST_LIST_ADD_ERROR: {
      return assign({}, state, { error: action.payload })
    }
    case POST_LIST_ADD_FULFILLED: {
      const data = [action.payload.data[0], ...cloneDeep(state.data, { id: action.payload.id })]
      return assign({}, state, { data, error: null })
    }

    case POST_LIST_DELETE: {
      return state
    }
    case POST_LIST_DELETE_CANCELED: {
      return state
    }
    case POST_LIST_DELETE_ERROR: {
      return assign({}, state, { error: action.payload.error })
    }
    case POST_LIST_DELETE_FULFILLED: {
      const data = cloneDeep(state.data)
      remove(data, (post) => post.id === action.payload.data[0].id)
      remove(data, (post) => post.post_id === action.payload.data[0].id)
      return assign({}, state, { data, error: null })
    }

    case POST_LIST_FETCH: {
      if (action.payload.typeId !== state.typeId || action.payload.page === 1) {
        return assign(clone(POST_LIST_INITIAL_STATE), { typeId: action.payload.typeId })
      }
      return state
    }
    case POST_LIST_FETCH_CANCELED: {
      return state
    }
    case POST_LIST_FETCH_ERROR: {
      return assign({}, state, { error: action.payload, loaded: true })
    }
    case POST_LIST_FETCH_FULFILLED: {
      if (!action.payload.pagination || action.payload.pagination.current_page === 1) {
        return assign(action.payload, { loaded: true })
      }

      state.data.push(...action.payload.data)
      return assign({}, state, {
        error: action.payload.error,
        loaded: true,
        pagination: action.payload.pagination,
      })
    }

    case POST_REACTION_ADD: {
      return addReaction(state, action)
    }
    case POST_REACTION_ADD_CANCELED: {
      return state
    }
    case POST_REACTION_ADD_ERROR: {
      return delReaction(state, action)
    }
    case POST_REACTION_ADD_FULFILLED: {
      return state
    }

    case POST_REACTION_DELETE: {
      return delReaction(state, action)
    }
    case POST_REACTION_DELETE_CANCELED: {
      return state
    }
    case POST_REACTION_DELETE_ERROR: {
      return addReaction(state, action)
    }
    case POST_REACTION_DELETE_FULFILLED: {
      return state
    }

    default:
  }
  return state
}
